export default function(loading) {
    return (loading ? 'fa fa-spinner fa-spin':"fa fa-search")
}


// WEBPACK FOOTER //
// ./src/utils/constants/searchIcon.js